module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/collabs-logos/charles-river-2b49cd10adf21022cd3fcc46120633cd.svg";